export const regexSpecialCharacters = /[!™"®©',;()?:]/g;

export const stripSpecialCharacters = (input: string) =>
    input
        .replaceAll('&', 'and')
        .replaceAll('é', 'e')
        .replaceAll('–', '-')
        .replaceAll('—', '-')
        .replace(regexSpecialCharacters, '');
